import React from "react";
import Skeleton from "@df-mobile/skeleton";
import "./index.less";

const DetailSkeleton = () => {
  const bgColor = {
    background: "#F0F0F0",
  };
  return (
    <div className="detail-skeleton-wrapper">
      <div className="detail-top">
        <Skeleton.Image
          animation
          width="100%"
          height="100%"
          style={{ ...bgColor }}
        />
        {[1, 2]?.map((_, index: number) => {
          return (
            <div className="detail-content" key={`detail_skeleton_${index}`}>
              <div className="common-item">
                <Skeleton.Image
                  animation
                  width="120px"
                  height="18px"
                  style={{ ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="240px"
                  height="18px"
                  style={{ marginTop: "15px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
              </div>
              <div className="common-item">
                <Skeleton.Image
                  animation
                  width="120px"
                  height="18px"
                  style={{ ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="120px"
                  height="18px"
                  style={{ marginTop: "15px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="240px"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="160px"
                  height="18px"
                  style={{ marginTop: "30px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="100%"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
                <Skeleton.Image
                  animation
                  width="240px"
                  height="18px"
                  style={{ marginTop: "8px", ...bgColor }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetailSkeleton;
